import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Link,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useCallback, useContext } from "react";
import { useForm } from "react-hook-form";
import { AuthContext } from "../../providers";
import { Trans, useTranslation } from "react-i18next";

const LoginForm = () => {
  const { t } = useTranslation();
  const { signIn } = useContext(AuthContext);
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = useCallback(
    (values) => {
      return new Promise((resolve) => {
        signIn(values).catch((error) => {
          if (!toast.isActive(error.message)) {
            toast({
              id: error.message,
              title: error.message,
              status: "error",
              position: "top",
              duration: 5000,
            });
          }
          resolve();
        });
      });
    },
    [signIn, toast],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack alignItems={"start"} gap={4}>
        <FormControl isInvalid={errors.username}>
          <FormLabel htmlFor={"username"}>
            <Trans>login.username.title</Trans>
          </FormLabel>
          <Input
            backgroundColor={"white"}
            htmlSize={100}
            id={"username"}
            placeholder={t("login.username.placeholder")}
            size={"sm"}
            type={"text"}
            {...register("username", {
              required: t("login.username.required"),
            })}
          />
          <FormErrorMessage>
            {errors.username && errors.username.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={errors.password}>
          <FormLabel htmlFor={"password"}>
            <Trans>login.password.title</Trans>
          </FormLabel>
          <Input
            backgroundColor={"white"}
            htmlSize={100}
            id={"password"}
            placeholder={t("login.password.placeholder")}
            size={"sm"}
            type={"password"}
            {...register("password", {
              required: t("login.password.required"),
            })}
          />
          <FormErrorMessage>
            {errors.password && errors.password.message}
          </FormErrorMessage>
        </FormControl>
        <Button
          alignSelf={"stretch"}
          isLoading={isSubmitting}
          size={"sm"}
          type={"submit"}
          variant={"secondary"}
        >
          <Trans>login.signIn</Trans>
        </Button>
        <Link>
          <Trans>login.passwordForgotten</Trans>
        </Link>
      </VStack>
    </form>
  );
};

export default React.memo(LoginForm);
